import {TaskType} from "../../models/TaskType";
import {WrapperFactory} from "../WrapperFactory";

let taskTypesApi = {
    async get(token, companyId, params = {}) {
        let response = await window.axios.get('/api/task-types', {
            params: {
                api_token: token,
                company_logged: companyId,
                ...params
            }
        });

        let wrapper = WrapperFactory.fromResponse(response.data)
        wrapper.transform(e=>new TaskType(e));
        return wrapper
    },
    async create(taskType, token, companyId){
        let response = await window.axios.post('/api/task-types', taskType, {
            params:{
                api_token:token,
                company_logged:companyId
            }
        });
        return new TaskType(response.data);
    },
    async edit(taskType, token, companyId){
        let response = await window.axios.put('/api/task-types/'+taskType.id, taskType, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });

        return new TaskType(response.data);
    },
}

export default taskTypesApi